import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../../config/apila";
import { APIMS } from "../../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { PulseLoader } from "react-spinners";
import ModalSwitchStudent from "./modal/SwitchStudent";
import ModalSwitchWalas from "./modal/SwitchWalas";

const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(to right, #ddeaffff 8%, #f4f8ffff 18%, #ddeaffff 33%);
    background-size: 800px 104px;
  }
  .shimmer-select { height: 35px; border-radius: 4px; }

    .walas-card {
    display: grid;
    grid-template-columns: 210px minmax(0, 1fr) auto;
    align-items: stretch;
    width: 100%;
    margin-top: 16px;
    margin-bottom: 16px;
    background: #ffffff;
    border: 1px solid #dfe5f4;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(42, 58, 105, 0.07);
    overflow: hidden;
  }

  .walas-card__title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 112px;
    padding: 20px 22px;
    border-right: 1px solid #e5e9f2;
    color: #315fc5;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
  }

  .walas-card__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    border-radius: 12px;
    background: #eef3ff;
    color: #315fc5;
    font-size: 18px;
  }

  .walas-card__details {
    min-width: 0;
    padding: 18px 30px;
  }

  .walas-card__row {
    display: grid;
    grid-template-columns: 112px 16px minmax(0, 1fr);
    align-items: center;
    min-height: 38px;
    font-size: 14px;
  }

  .walas-card__row + .walas-card__row {
    border-top: 1px solid #edf0f6;
  }

  .walas-card__label {
    color: #25324b;
    font-weight: 700;
  }

  .walas-card__separator {
    color: #7d879b;
    text-align: center;
  }

  .walas-card__name {
    min-width: 0;
    color: #17233c;
    font-weight: 500;
    overflow-wrap: anywhere;
  }

  .walas-card__action {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 190px;
    padding: 20px 24px;
    border-left: 1px solid #e5e9f2;
  }

  .walas-card__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 42px;
    padding: 9px 16px;
    border: 1px solid #4169d8;
    border-radius: 10px;
    background: #ffffff;
    color: #315fc5;
    font-size: 13px;
    font-weight: 700;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .walas-card__button:hover {
    background: #315fc5;
    color: #ffffff;
    border-color: #315fc5;
    box-shadow: 0 6px 16px rgba(49, 95, 197, 0.2);
  }

  @media (max-width: 900px) {
    .walas-card {
      grid-template-columns: 170px minmax(0, 1fr) auto;
    }

    .walas-card__title {
      padding: 18px;
    }

    .walas-card__details {
      padding: 16px 20px;
    }

    .walas-card__action {
      min-width: 160px;
      padding: 16px;
    }
  }

  @media (max-width: 780px) {
    .walas-card {
      display: block;
      border-radius: 12px;
    }

    .walas-card__title {
      justify-content: flex-start;
      min-height: auto;
      padding: 14px 16px;
      border-right: 0;
      border-bottom: 1px solid #e5e9f2;
    }

    .walas-card__icon {
      width: 38px;
      height: 38px;
      font-size: 16px;
    }

    .walas-card__details {
      padding: 8px 16px;
    }

    .walas-card__row {
      grid-template-columns: 96px 12px minmax(0, 1fr);
      min-height: 48px;
      font-size: 13px;
    }

    .walas-card__action {
      justify-content: flex-end;
      min-width: 0;
      padding: 14px 16px;
      border-left: 0;
      border-top: 1px solid #e5e9f2;
    }

    .walas-card__button {
      width: 100%;
    }
  }
`;

export default function ConfigStudent() {
  document.title = "Konfigurasi Kelas";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);

  const [searchKeyword, setSearchKeyword] = useState("");

  const [getData, setGetData] = useState([]);
  const [dataWalas, setDataWalas] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [id, setId] = useState();
  const [dataUpdate, setDataUpdate] = useState();
  const [modalUpdate, setModalUpdate] = useState(false);
  const [modalSwitchStudent, setModalSwitchStudent] = useState(false);
  const [modalSwitchWalas, setModalSwitchWalas] = useState(false);

  const id_user = localStorage.getItem("id_admin");
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
  });

   const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const fetchParams = useMemo(() => ({
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  }), [token]);

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
      const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  const fetchInit = useCallback(async () => {
    setLoading(true);
    try {
      const [branchRes, semesterRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          fetchParams
        ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          fetchParams
        ),
      ]);

      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          setForm2(prev => ({ ...prev, ysb_branch_id: branches[0].branch_code }));
        }
      }

      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        setGetDataSemesterMap(semesters);
        const active = semesters.find(s => s.status === 1) || semesters[0];
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2(prev => ({ ...prev, ysb_semester_id: active.id }));
        }
      }
    } catch (err) {
      swal({ title: "Failed", text: "Gagal memuat data master", icon: "error" });
    } finally {
      setLoading(false);
    }
  }, [fetchParams, page, limit, ascending, descending, keyword, storageBranchGroping, storageLevel]);

  useEffect(() => { fetchInit(); }, [fetchInit]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;
      setLoadingSchool(true); 
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );
        if (res?.status === 200) {
          let schools = res.data.data || [];

          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter(
              (s) => s.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          if (schools.length > 0) {
            setGetDataLevel([]);
            setGetDataKelas([]);
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
            }));
          } else {
            setGetDataLevel([]);
            setGetDataKelas([]);
            setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
          initSchoolDone.current = true;
          setLoadingSchool(false); 
          setLoading(false);       
      }
    },[ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);

  const fetchLevelsBySchool = useCallback(async (schoolId, branchId) => {
    if (!schoolId) return;
    setLoadingLevel(true);
    try {
      const res = await APIMS.get(
        `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
        fetchParams
      );
      let levels = res.data.data || [];
      levels = levels.filter(x => x.ysb_school_id === schoolId);
      setGetDataLevel(levels);

      if (levels.length > 0) {
        setForm2(prev => ({ ...prev, ysb_grade_level_id: levels[0].id, ysb_kelas_id: "" }));
      }
    } catch (err) { console.error(err); } finally { setLoadingLevel(false); }
  }, [fetchParams, page, limit, ascending, storageLevel]);

  const sortKelas = (kelas) => {
    return [...kelas].sort((a, b) =>
      (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
    );
  };

  useEffect(() => { if (form2.ysb_school_id) fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id); }, [form2.ysb_school_id, form2.ysb_branch_id]);


   // =========================
  // Fetch kelas saat tingkatan berubah
  // =========================
  const fetchKelasByLevel = useCallback(
    async (gradeLevelId, schoolId, branchId) => {
      initKelasDone.current = false;

      if (!gradeLevelId) return;

      setLoadingKelas(true);
      try {
        const res = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let kelas = res.data?.data || [];

          kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
          if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
          if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

          kelas = sortKelas(kelas);
          setGetDataKelas(kelas);

          if (kelas.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_kelas_id: kelas[0].id,
            }));
          } else {
            setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
          }
        }
      } catch (err) {
        console.error(err);
        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      } finally {
        initKelasDone.current = true;
        setLoadingKelas(false);
      }
    }, [fetchParams]
  );

  useEffect(() => {
    if (!form2.ysb_grade_level_id) {
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      return;
    }

    setGetDataKelas([]);
    setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
    fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  const sortStudentsByName = (students = []) => {
    return [...students].sort((a, b) => {
      const nameA = safeStr(a?.name_student).trim();
      const nameB = safeStr(b?.name_student).trim();

      return nameA.localeCompare(nameB, "id", {
        sensitivity: "base",
        numeric: true,
      });
    });
  };

  const filteredStudents = useMemo(() => {
    const search = safeStr(searchKeyword).trim().toLowerCase();

    if (!search) {
      return getData;
    }

    return getData.filter((student) => {
      const namaSiswa = safeStr(student?.name_student)
        .trim()
        .toLowerCase();

      const nisnSiswa = safeStr(student?.nisn)
        .trim()
        .toLowerCase();

      return (
        namaSiswa.includes(search) ||
        nisnSiswa.includes(search)
      );
    });
  }, [getData, searchKeyword]);

  const GetResponseData = useCallback(async () => {
    if (!form2.ysb_semester_id || !form2.ysb_kelas_id) return;

    setIsFetching(true);
    try {
      const response = await APILA.post(
        "/api/semester-assignments/super",
        {
          page: 1,
          limit: 1000,
          ascending: true,
          search: "",
          branch: form2.ysb_branch_id,
          level: storageLevel || "user",
          ysb_semester_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_grade_level_id: form2.ysb_grade_level_id,
          ysb_kelas_id: form2.ysb_kelas_id,
        },
        fetchParams
      );

      // if (response?.status === 200) {
      //   setGetData(response.data.data || []);
      //   setDataWalas(response.data.data_walas || null);
      // }
      if (response?.status === 200) {
        const students = response.data?.data || [];

        const sortedStudents = sortStudentsByName(students);

        setGetData(sortedStudents);
        setDataWalas(response.data?.data_walas || null);
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  }, [form2, fetchParams, storageLevel]);

  useEffect(() => {
    const schoolReady = !loadingSchool && !!form2.ysb_school_id;
    const gradeReady = !loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);
    const kelasReady = !loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !schoolReady || !gradeReady || !kelasReady
    ) return;

    firstLoadDone.current = true;

    (async () => {
      setIsFetching(true);
      await GetResponseData();
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    loadingSchool,
    loadingLevel,
    loadingKelas,
    getDataLevel.length,
    getDataKelas.length,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm2(prev => ({ ...prev, [name]: value }));
    if (!isFirstLoad) setIsFilterDirty(true);
  };

    // =========================
  // Filter complete 
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
    (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));

  const handleCari = async () => {
    if (loadingSchool || loadingLevel || loadingKelas) {
      swal({ title: "Mohon tunggu", text: "Data masih dimuat...", icon: "info", timer: 1500 });
      return;
    }

    setIsFetching(true);
    setHasSearched(false);
    await GetResponseData();
    setHasSearched(true);
    setIsFilterDirty(false);
    setIsFetching(false);
  };

  const viewModalSwitchStudent = (id, row) => {
    setId(id)
    setModalSwitchStudent(true)
    setDataUpdate(row)
  }

  const viewModalSwitchWalas = (id, row) => {
    setId(id)
    setModalSwitchWalas(true)
    setDataUpdate(row)
  }

  const deleteById = async (id, row) => {
    // console.log(row)
    Swal.fire({
      title: 'Apakah Kamu Yakin?',
      text: `Menghapus data ini`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus'
    }).then( async (result) => {
      if(result.isConfirmed) {
        const response =  await APILA.post("/api/semester-assignments/delete-assignment",
          {
            ysb_semester_id: row.ysb_semester_id,
            ysb_branch_id: row.ysb_branch_id,
            ysb_school_id: row.ysb_school_id,
            ysb_grade_level_id: row.ysb_grade_level_id,
            ysb_kelas_id: row.ysb_kelas_id,
            ysb_student_id: row.ysb_student_id,
            user_id: output_id_user
          },fetchParams);
        if (response.data.error == false) {
          GetResponseData()
          swal({
            title: 'Success',
            text: "Data berhasil di hapus!",
            icon: 'success',
            timer: 3000,
            buttons: false
          });
        }  
      }
    })
  };

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  return (
    <>
    {modalSwitchStudent && <ModalSwitchStudent GetResponseData={GetResponseData} id={id} dataUpdate={dataUpdate} show={modalSwitchStudent} onHide={() => setModalSwitchStudent(false)} />}
    {/* {modalSwitchWalas && <ModalSwitchWalas GetResponseData={GetResponseData} id={id} dataUpdate={dataUpdate} show={modalSwitchWalas} onHide={() => setModalSwitchWalas(false)} />} */}
    {modalSwitchWalas && (
      <ModalSwitchWalas
        GetResponseData={GetResponseData}
        id={id}
        dataUpdate={dataUpdate}
        dataWalas={dataWalas}
        show={modalSwitchWalas}
        onHide={() => setModalSwitchWalas(false)}
      />
    )}
    
      <style>{shimmerStyle}</style>

      <div className="body">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faUserGraduate} />
              </span>
              <h4 className="page-title-text">Konfigurasi Kelas</h4>
            </div>
          </div>

          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/kelas">Kelas</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li
                className="custom-breadcrumb-item active"
                aria-current="page"
              >
                Konfigurasi Kelas
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content">
          {isTabletOrMobile ? (
            <div className="title-page">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                              <select
                                className="mr-2"
                                name="ysb_semester_id"
                                value={form2.ysb_semester_id}
                                onChange={handleChange}
                                style={{
                                  border: "1px solid #d9defa",
                                  borderRadius: "12px",
                                  fontSize: "14px",
                                  padding: "10px 12px",
                                  background: "#fff",
                                }}
                              >
                                <option value="" hidden>
                                  {namaTA} (Semester {namaSmstr})
                                </option>
                                {getDataSemesterMap.map((user, index) => (
                                  <option key={index} value={user?.id}>
                                    {user?.name_year} (Semester {user?.semester})
                                  </option>
                                ))}
                              </select>
                            </Row>
              
                            <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                              <select
                                className="mr-2"
                                name="ysb_branch_id"
                                value={form2.ysb_branch_id}
                                onChange={handleChange}
                                style={{
                                  border: "1px solid #d9defa",
                                  borderRadius: "12px",
                                  fontSize: "14px",
                                  padding: "10px 12px",
                                  background: "#fff",
                                }}
                              >
                                <option value="" hidden>
                                  Pilih Cabang
                                </option>
                                {getDataBranch.map((user, index) => (
                                  <option key={index} value={user?.branch_code}>
                                    {user?.branch_name}
                                  </option>
                                ))}
                              </select>
                            </Row>
              
                            <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                               <select
                                        className="mr-2"
                                        name="ysb_school_id"
                                        value={form2.ysb_school_id}
                                        onChange={handleChange}
                                        disabled={loadingSchool}
                                        style={{
                                          border: "1px solid #d9defa",
                                            borderRadius: "12px",
                                            fontSize: "14px",
                                            padding: "10px 12px",
                                          backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                                          cursor: loadingSchool ? "not-allowed" : "pointer",
                                        }}
                                      >
                                        <option value="" hidden>
                                          {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                                        </option>
              
                                        {!loadingSchool &&
                                          getDataSchool.map((user, index) => (
                                            <option key={index} value={user?.school_code}>
                                              {user?.school_name}
                                            </option>
                                          ))}
                                      </select>
                                    
              
                                      
              
                                     
                            </Row>
              
                            <Row style={{ marginTop: "10px", padding: "0 12px" }}>
              <select
                                        className="mr-2"
                                        name="ysb_grade_level_id"
                                        value={form2.ysb_grade_level_id}
                                        onChange={handleChange}
                                        disabled={loadingLevel}
                                        style={{
                                          border: "1px solid #d9defa",
                                            borderRadius: "12px",
                                            fontSize: "14px",
                                            padding: "10px 12px",
                                          backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                                          cursor: loadingLevel ? "not-allowed" : "pointer",
                                        }}
                                      >
                                        <option value="" hidden>
                                          {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                                        </option>
              
                                        {!loadingLevel &&
                                          getDataLevel.map((user, index) => (
                                            <option key={index} value={user?.id}>
                                              {user?.name_level}
                                            </option>
                                          ))}
                                      </select>
                            </Row>
              
                            <Row style={{ marginTop: "10px", padding: "0 12px" }}>
               <select
                                        className="mr-2"
                                        name="ysb_kelas_id"
                                        value={form2.ysb_kelas_id}
                                        onChange={handleChange}
                                        disabled={loadingKelas}
                                        style={{
                                          border: "1px solid #3f5bea",
                                          border: "1px solid #d9defa",
                                            borderRadius: "12px",
                                            fontSize: "14px",
                                            padding: "10px 12px",
                                          backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                                          cursor: loadingKelas ? "not-allowed" : "pointer",
                                        }}
                                      >
                                        <option value="" hidden>
                                          {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                                        </option>
              
                                        {!loadingKelas &&
                                          getDataKelas.map((user, index) => (
                                            <option key={index} value={user?.id}>
                                              {user?.name_kelas}
                                            </option>
                                          ))}
                                      </select>
                            </Row>
              
                            <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                              <button
                                onClick={handleCari}
                                disabled={!isFilterComplete}
                                className="btn"
                                style={{
                                  fontSize: "13px",
                                  padding: "10px 16px",
                                  borderRadius: "12px",
                                  backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                                  color: "#fff",
                                  cursor: !isFilterComplete ? "not-allowed" : "pointer",
                                }}
                              >
                                Cari
                              </button>
                            </Row>
              
            </div>
          ) : (
            <>
              <div className="mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      
                    </div>
                    
                    <div className="d-flex">
                       <div className="shimmer shimmer-select mr-2" style={{width:120, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:120, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:70, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="mb-3 mt-1">
                      <div className="d-flex">
                        <select
                          className="mr-2"
                          name="ysb_semester_id"
                          value={form2.ysb_semester_id}
                          onChange={handleChange}
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                        >
                          <option value="" hidden>
                            {namaTA} (Semester {namaSmstr})
                          </option>
                          {getDataSemesterMap.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_year} (Semester {user?.semester})
                            </option>
                          ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_branch_id"
                          value={form2.ysb_branch_id}
                          onChange={handleChange}
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                        >
                          <option value="" hidden>
                            Pilih Cabang
                          </option>
                          {getDataBranch.map((user, index) => (
                            <option key={index} value={user?.branch_code}>
                              {user?.branch_name}
                            </option>
                          ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_school_id"
                          value={form2.ysb_school_id}
                          onChange={handleChange}
                          disabled={loadingSchool}
                          style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                            cursor: loadingSchool ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingSchool ? "Memuat sekolah..." : "Pilih Sekolah"}
                          </option>

                          {!loadingSchool &&
                            getDataSchool.map((user, index) => (
                              <option key={index} value={user?.school_code}>
                                {user?.school_name}
                              </option>
                            ))}
                        </select>

                       
                      </div>

                      <div className="mt-3 d-flex">
                         <select
                          className="mr-2"
                          name="ysb_grade_level_id"
                          value={form2.ysb_grade_level_id}
                          onChange={handleChange}
                          disabled={loadingLevel}
                          style={{
                            border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                            cursor: loadingLevel ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingLevel ? "Memuat tingkatan..." : "Pilih Tingkatan"}
                          </option>

                          {!loadingLevel &&
                            getDataLevel.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_level}
                              </option>
                            ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_kelas_id"
                          value={form2.ysb_kelas_id}
                          onChange={handleChange}
                          disabled={loadingKelas}
                          style={{
                           border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                            backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                            cursor: loadingKelas ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingKelas ? "Memuat kelas..." : "Pilih Kelas"}
                          </option>

                          {!loadingKelas &&
                            getDataKelas.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_kelas}
                              </option>
                            ))}
                        </select>

                        <button
                          onClick={handleCari}
                          disabled={!isFilterComplete}
                          className="btn"
                          style={{
                            fontSize: "13px",
                             padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                            color: "#fff",
                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                          }}
                        >
                          Cari
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
            
          )}

          {isFetching && <div className="text-center my-4"><PulseLoader color="#3f5bea" /></div>}

          {hasSearched && !isFetching && (
            <Col xl="12" sm="12">
              <div className="mt-3">
                
                {/* {dataWalas && (
                  <div className="alert alert-info mt-3 d-flex align-items-center justify-content-between">
                    <h6
                      style={{
                        fontSize: "14px",
                        marginBottom: 0,
                        lineHeight: "1.5",
                      }}
                    >
                      <strong>Wali Kelas:</strong> {dataWalas.name_walas}
                      {dataWalas.name_walas_2 && (
                        <> & Wali Kelas 2: {dataWalas.name_walas_2}</>
                      )}
                    </h6>

                    <div className="ml-auto">
                      <button
                        onClick={() =>
                          viewModalSwitchWalas(getData[0]?.id, getData[0])
                        }
                        className="btn btn-create mr-2"
                        style={{
                          borderRadius: 12,
                          padding: "8px 14px",
                          boxShadow: "0 10px 24px rgba(108, 99, 255, 0.18)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <FontAwesomeIcon icon={faPenToSquare} /> Edit Walas
                      </button>
                    </div>
                  </div>
                )} */}

                {dataWalas && (
                  <div className="walas-card">
                    <div className="walas-card__title">
                      <span className="walas-card__icon">
                        <FontAwesomeIcon icon={faUserGraduate} />
                      </span>

                      <span>Wali Kelas</span>
                    </div>

                    <div className="walas-card__details">
                      <div className="walas-card__row">
                        <span className="walas-card__label">
                          Utama
                        </span>

                        <span className="walas-card__separator">
                          :
                        </span>

                        <span className="walas-card__name">
                          {dataWalas?.name_walas || "-"}
                        </span>
                      </div>

                      <div className="walas-card__row">
                        <span className="walas-card__label">
                          Pendamping
                        </span>

                        <span className="walas-card__separator">
                          :
                        </span>

                        <span className="walas-card__name">
                          {dataWalas?.name_walas_2 || "-"}
                        </span>
                      </div>
                    </div>

                    <div className="walas-card__action">
                      <button
                        type="button"
                        className="walas-card__button"
                        onClick={() =>
                          viewModalSwitchWalas(
                            getData[0]?.id,
                            getData[0]
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faPenToSquare} />

                        <span>Edit Walas</span>
                      </button>
                    </div>
                  </div>
                )}

                <div className="at-search">
                  <input
                    className="at-input"
                    placeholder="Cari Siswa / NISN"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  />
                </div>


                <Col xl="12" sm="12">
                  <div className="mt-3">
                    <div className="body-table">
                      <div className="">
                        <table className="table table-laporan-adab table-hover table-bordered" id="basic-datatable">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center", border: "1px solid #e0e0e0ff", width: 40 }}>No</th>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>Nama</th>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>Nisn</th>
                              <th style={{textAlign: "center", border: "1px solid #e0e0e0ff"}}>Aksi</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filteredStudents.length === 0 ? (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  {searchKeyword.trim()
                                    ? `Siswa dengan pencarian "${searchKeyword}" tidak ditemukan`
                                    : "Data tidak ditemukan"}
                                </td>
                              </tr>
                            ) : (
                              filteredStudents.map((row, index) => (
                                <tr key={row?.id || row?.ysb_student_id || index}>
                                  <td
                                    style={{
                                      lineHeight: "2",
                                      textAlign: "center",
                                    }}
                                  >
                                    {index + 1}
                                  </td>

                                  <td style={{ fontSize: "13px" }}>
                                    {toTitleCase(row?.name_student)}
                                  </td>

                                  <td
                                    style={{
                                      lineHeight: "2",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row?.nisn || "-"}
                                  </td>

                                  <td className="text-center">
                                    <button
                                      className="button-edit button-table text-center"
                                      onClick={() =>
                                        viewModalSwitchStudent(row?.id, row)
                                      }
                                    >
                                      Pindah Kelas
                                    </button>

                                    <button
                                      className="button-delete button-table ml-3"
                                      onClick={() => {
                                        deleteById(row?.id, row);
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTrash} /> Hapus
                                    </button>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </Col>

              </div>
            </Col>
          )}
        </div>
      </div>
    </>
  );
}